module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kb-Lb.34a3693a.png";